























import { Component, Vue } from "vue-property-decorator";
import Project from "./Project.vue";
import ProjectDetails from "./ProjectDetails";

@Component({
  components: {
    Project
  }
})
export default class Portfolio extends Vue {
  projects: ProjectDetails[] = [
    {
      name: "Smart EV Charging Station",
      slug: "smart-ev-charging-station",
      description:
        "Data analytics and web dashboard for EV charging stations, for a capstone design course",
      keywords: ["AWS", "Spark", "project-management"]
    },
    {
      name: "peijun.dev",
      slug: "peijun-dev",
      description: "This website!",
      keywords: ["Vue", "Docker", "continuous-deployment"]
    },
    {
      name: "cloudflare-ddns",
      slug: "cloudflare-ddns",
      description: "Update Cloudflare DNS records using Terraform",
      keywords: ["Terraform", "Cloudflare", "DNS"]
    },
    {
      name: "ohs",
      slug: "ohs",
      description: "Schedule office hours with professors",
      keywords: [
        "Python",
        "Flask",
        "GraphQL",
        "React",
        "Docker",
        "continuous-integration"
      ]
    },
    {
      name: "Option",
      slug: "python-option",
      description: "Rust like Option and Result types in Python",
      keywords: ["functional-programming", "Python"]
    },
    {
      name: "musicview",
      slug: "musicview",
      description: "A terminal music player",
      keywords: ["Python", "Ncurses", "multithreading"]
    },
    {
      name: "YasenBaka",
      slug: "yasen-baka",
      description: "Asynchronous chat bot",
      keywords: ["asyncio", "Python", "Docker"]
    }
  ];
}
